<template>
    <div>
        <v-dialog v-model="confirmar" max-width="375" persistent>
            <v-card :loading="loading">
                <v-card-title class="headline">¿Está seguro en restablecer la contraseña?</v-card-title>

                <v-card-text>
                Usuario: {{nombre}}
                </v-card-text>

                <v-card-actions>
                <div class="flex-grow-1"></div>

                <v-btn color="blue-grey darken-1" outlined text @click="$emit('cancelar')">Cancelar</v-btn>
                <v-btn color="blue-grey darken-1" dark @click="resetPassword()">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="confirmado" max-width="375" persistent>
            <v-card>
                <v-card-title class="headline">Nueva contraseña:</v-card-title>
                <v-card-title>{{newPass}}</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="blue-grey darken-1" dark @click="$emit('cancelar')">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters} from 'vuex'

export default {
    props:['mostrar','id','nombre'],
    data: () => ({
        loading: false,
        confirmar: true,
        confirmado: false,
        newPass: null
    }),
    computed: {
        ...mapGetters([
            "httpURL",
            "sessionToken"
        ])
    },
    created(){

    },
    methods:{
        resetPassword(){
            this.loading = true;
            axios.put(this.httpURL+'/usuario/resetPassword/'+this.id,{},{headers:{token:this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                if( res.data.ok ){
                    this.newPass = res.data.pass;
                    this.loading = false;
                    this.confirmar = false;
                    this.confirmado = true;
                }else{
                    this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: res.data.mensaje });
                    this.loading = false;
                }
            })
            .catch(error => {
                // console.log('Error: '+error);
                this.loading = false;
                this.$notify({ group: 'gral_notif', type:"error", duration:1500, speed: 500, text: 'Ocurrió un error al hacer la petición' });
            });
        }
    }
}
</script>
